(function () {
  var PATHS = [
    "/pages/ea_no-one-you-know-dave-rowntrees-early-blur-photos",
    "/pages/no-one-you-know-dave-rowntrees-early-blur-photos"
  ];
  var LOGO_SRC = "https://cdn.shopify.com/s/files/1/0943/2301/5953/files/logo_1._1_a2c88a24-0ef1-4280-9454-0813086f2a79.jpg?v=1755583338";
  var path = (window.location.pathname || "").replace(/\/+$/, "/");
  if (!PATHS.includes(path)) return;

  function ensureCSS() {
    if (document.querySelector('style[data-brand-logo-css]')) return;
    var css = document.createElement("style");
    css.setAttribute("data-brand-logo-css", "");
    css.textContent =
      ".brand-logo-wrap{display:flex;justify-content:center;margin:10px 0}" +
      ".brand-logo{display:inline-flex;align-items:center; justify-content: center}" +
      ".brand-logo img{display:block;max-width:60%;height:auto}" +
      "@media (max-width:600px){.brand-logo img{max-width:100%}}";
    document.head.appendChild(css);
  }

  function inject(parent) {
    ensureCSS();
    if (!parent || parent.querySelector(".brand-logo-wrap")) return;
    var wrap = document.createElement("div");
    wrap.className = "brand-logo-wrap";
    var link = document.createElement("a");
    link.className = "brand-logo";
    link.href = "/";
    link.setAttribute("aria-label", "Brand Logo");
    var img = document.createElement("img");
    img.src = LOGO_SRC;
    img.alt = "Brand Logo";
    img.decoding = "async";
    img.loading = "lazy";
    link.appendChild(img);
    wrap.appendChild(link);
    parent.insertAdjacentElement("afterbegin", wrap);
  }

  function findSlot() {
    var details = document.querySelector(".lhs .ch-column-details");
    if (!details) return null;
    var p = details.querySelector(".p-name");
    var a = details.querySelector(".a-name");
    return (p && p.parentElement) || (a && a.parentElement) || details;
  }

  function tryOnce() {
    var slot = findSlot();
    if (!slot) return false;
    inject(slot);
    return true;
  }

  function onReady() {
    if (tryOnce()) return;
    var root = document.querySelector(".lhs") || document.body;
    var mo = new MutationObserver(function () { if (tryOnce()) mo.disconnect(); });
    mo.observe(root, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 3000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }
})();
